import { useMediaQuery } from '../../hooks'
import { flagsImage, flagsCoordinates } from '../../static/img/flags'

interface Coordinates {
  meta: {
    type: string
    version: string
    app: string
  }
  spritesheets: {
    image: string
    sprites: {
      name: string
      position: { x: number; y: number }
      dimension: { w: number; h: number }
    }[]
  }[]
}

const coordinates: Coordinates = flagsCoordinates

interface Props {
  code: string
  isSelected?: boolean
}

export const Flag = ({ code, isSelected }: Props) => {
  const isMobile = useMediaQuery(({ screens }) => `(max-width: ${screens.md})`)

  const coordinate = coordinates.spritesheets[0].sprites.find(
    (coordinate) => coordinate.name.toLowerCase() === code.toLowerCase(),
  )!

  if (!coordinate) return <div className="w-4 h-4" />

  const { position } = coordinate

  return (
    <div
      className={`w-4 h-4 ${isSelected ? 'sm:w-4 sm:h-4' : 'sm:w-6 sm:h-6'}`}
    >
      <div
        className="relative w-16 h-16 overflow-hidden border-[3px] rounded-circle border-primary-default"
        style={{
          transform: `translate(-50%, -50%) ${
            isMobile || isSelected ? 'scale(0.25)' : 'scale(0.375)'
          } translate(50%, 50%)`,
        }}
      >
        <div
          style={{
            position: 'relative',
            top: `${-position.y}px`,
            left: `${-position.x}px`,
          }}
        >
          <img
            draggable="false"
            alt="flags"
            className="max-w-[none]"
            // Image import can chagne to string (vite) or StaticImportAsset (next.js) depending on bundler
            src={
              typeof flagsImage === 'string'
                ? flagsImage
                : 'src' in flagsImage
                  ? (flagsImage as { src: string }).src
                  : ''
            }
          />
        </div>
      </div>
    </div>
  )
}
